import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {useAuthStore} from '@toolify/client/src/stores/AuthStore/useAuthStore'
import {useWorkspaceStore} from '@toolify/client/src/stores/WorkspaceStore/useWorkspaceStore'
import {EntityType} from '@toolify/server/src/services/EntityService/enum/EntityType'
import {IUserResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IUserResponseInstance'
import {getRedirectToLastVisitedResourceForWorkspaceHome} from '@toolify/client/src/pages/WorkspacePage/getRedirectToLastVisitedResourceForWorkspaceHome'
import {getRedirectToUpgradeIfNeverSubscribed} from '@toolify/client/src/pages/WorkspacePage/getRedirectToUpgradeIfNeverSubscribed'

export function beforeWorkspaceHomeRouterHookFactory(pinia: Pinia) {
  return function beforeWorkspaceHomeRouterHook(
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
  ) {
    const authStore = useAuthStore(pinia)
    const currentUser = authStore.currentEntity?.entityType === EntityType.User
      ? (authStore.currentEntity.payload as IUserResponseInstance)
      : null
    if (currentUser?.isSuperAdmin) {
      return
    }
    const workspaceStore = useWorkspaceStore(pinia)
    const billingRedirect = getRedirectToUpgradeIfNeverSubscribed(
      to,
      workspaceStore.currentWorkspace?.hasHadSubscription,
      workspaceStore.currentWorkspace?.planId,
      workspaceStore.currentWorkspace?.isSubscriptionRequired,
    )
    if (billingRedirect) {
      return billingRedirect
    }
    const isAlreadyInWorkspace = Boolean(from.params.workspaceName)
      && from.params.workspaceName === to.params.workspaceName
    if(isAlreadyInWorkspace) {
      return
    }
    const redirect = getRedirectToLastVisitedResourceForWorkspaceHome(to, pinia)
    if (redirect) {
      return redirect
    }
  }
}
